module.exports = __webpack_public_path__ + "img/p1-info.2f30e072.jpg";